import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Employee";

export const EMPLOYEE_PREFIX_URL = PREFIX_URL;

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const UpdateNotificationSchedule = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/NotificationSchedule`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const RegisterWithPassword = () =>
  GENERATE_URL(`${PREFIX_URL}/RegisterWithPassword`, {});

export const Login = () => GENERATE_URL(`${PREFIX_URL}/Login`, {});

export const ResetPassword = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ResetPassword`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  UpdateNotificationSchedule,
  Delete,
  RegisterWithPassword,
  Login,
  ResetPassword,
};
